import { Card, CardHeader } from "@mui/material";
import React from "react";
import { withTranslation } from "react-i18next";
import logger from "../../../services/logger";
import Form from "../../common/form";
import {
  getFormTitleText,
  getJoiSchema,
  getStateObject,
} from "../../common/formUtils";
import blockJson from "./block.json"
import blockService from "./block.service";
import hostelService from "../hostel.service";

class BlockForm extends Form {
  constructor() {
    super();
    this.formJson = blockJson;
    this.state = {
      data: getStateObject(this.formJson.groups),
      errors: {},
      dropDowns: {},
    };
    this.schema = getJoiSchema(this.formJson.groups);
  }


  async componentDidMount() {
    this.getHostels();
    await this.populateForm();
  }


  async populateForm() {
    // const id = this.props.match.params.id;
    const id = this.props.id;
    if (id === "new") return;
    try {
      const { data } = await blockService.get(id);
      this.mapToViewModel(data);
    } catch (ex) {
      logger.error(ex);
    }
  }

  async getHostels(){
    const {data:hostels}=await hostelService.getAll();
    const dropDowns={...this.state.dropDowns}
    dropDowns.hostels=hostels;
    this.setState({dropDowns});
    }

  
  

  doSubmit = async (id) => {
    try {
      if (id === "new") {
        await blockService.create(this.state.data);
      } else {
        await blockService.partialUpdate(this.state.data,id);
      }
      this.props.onSave();
    } catch (ex) {
      logger.log(ex);
    }
  };

  render() {
    const { t } = this.props;
    const { dropDowns } = this.state;
    // const id = this.props.match.params.id;
    const id = this.props.id;


    const titleText = getFormTitleText(id, this.formJson.alias);

    return (
      <Card>
        <form onSubmit={(event) => this.handleSubmit(event, id)}>
          <CardHeader title={t(titleText)} />
          {this.renderForm(this.formJson, dropDowns)}
          {/* <CardContent>
            <Grid container item sm={12} md={12} direction="row-reverse">
              {this.renderMatButton(t(buttonText))}
              {this.renderMatButton(t("common:Reset"), "reset", "secondary")}
            </Grid>
          </CardContent> */}
        </form>
      </Card>
    );
  }
}

export default withTranslation(["block", "common"])(
  BlockForm
);
